module.exports = "<h3>Portfolio value across time</h3>\n<!-- <mat-grid-list *ngIf=\"chartData.length === 0\" cols=\"1\" rowHeight=\"500\">\n    <mat-grid-tile><mat-spinner></mat-spinner></mat-grid-tile>\n</mat-grid-list> -->\n<div id=\"{{divId}}\" [style.width.%]=\"100\" [style.height.px]=\"500\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/components/portfolio-chart/portfolio-chart.component.html
// module id = ../../../../../src/app/components/portfolio-chart/portfolio-chart.component.html
// module chunks = main